import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 13H6V9H4v6h16V9h-2z"
}), 'SpaceBarTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SpaceBarTwoTone.js
// module id = 6332
// module chunks = 2